import type { PickupDef } from '@nebulark/engine';

export const PICKUPS: PickupDef = {
  fallSpeed: 140,
  magnetRadius: 40,
  dropChance: 0.15,
};
